import microuniversoApi from "app/api/microuniversoApi"
import { atualizarItemAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"


import globalMU from "globalMU"

declare var window:any

export type DefinirVendaSobEncomendaItemInput = {
    
    identificadorItem:number,
    vendaSobEncomenda: boolean,
    itemOrcamentoLegado?: any
}

export async function definirVendaSobEncomendaItem(input: DefinirVendaSobEncomendaItemInput) {
    try {
        globalMU.blockUI()

        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirVendaSobEncomendaItem(
            store.getState().orcamento.IdentificadorOrcamento,
            input.identificadorItem, 
            input.vendaSobEncomenda)

        const atualizarOrcamento = () => {
            const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == input.identificadorItem);
            store.dispatch(atualizarItemAction({ identificador: input.identificadorItem, dados: itemAtualizado }))
            store.dispatch(sobrescreverInformacoesAction(orcamentoAtualizado))
        }

        
        atualizarOrcamento()


    } finally {
        globalMU.unblockUI()
    }
}